import React from 'react';
import styles from './ListHeader.module.scss';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const ListHeader = ({ isAllCardSelected, handleAllCardClick }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.listModeHeader}>
      <Checkbox
        list
        className={isAllCardSelected ? styles.activeAllListCheckbox : styles.listCheckBox}
        checked={isAllCardSelected}
        onClick={handleAllCardClick}
      />
      <span>{t('dashboard.video_list.title')}</span>
      <span>{t('dashboard.video_list.owner')}</span>
      <span>{t('dashboard.video_list.created')}</span>
      <span>{t('dashboard.video_list.last_update')}</span>
    </div>
  );
};

export default ListHeader;
